'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_React$Component) {
	_inherits(Filter, _React$Component);

	function Filter(props) {
		_classCallCheck(this, Filter);

		var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

		_this.state = {
			isLoading: true,
			options: []
		};

		_this.loadOptions.bind(_this)();
		return _this;
	}

	_createClass(Filter, [{
		key: 'loadOptions',
		value: function loadOptions() {
			var _this2 = this;

			var url = '/ajax/' + this.props.filter.type;
			var request = new Request(url, {
				credentials: 'same-origin',
				method: 'GET'
			});

			fetch(request).then(function (response) {
				return response.json();
			}).then(function (response) {
				return _this2.setState({
					isLoading: false,
					options: response
				});
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    onRemove = _props.onRemove,
			    wrapperClass = _props.wrapperClass,
			    rest = _objectWithoutProperties(_props, ['onRemove', 'wrapperClass']);

			var isLoading = this.state.isLoading;


			var options = this.props.options ? this.props.options : this.state.options;

			return _react2.default.createElement(
				'div',
				{ className: 'filter-wrapper show ' + (wrapperClass || '') },
				_react2.default.createElement(
					'div',
					{ className: 'remove-filter', onClick: onRemove },
					'Remove'
				),
				_react2.default.createElement(_Select2.default, _extends({
					isLoading: isLoading,
					options: options
				}, rest))
			);
		}
	}]);

	return Filter;
}(_react2.default.Component);

exports.default = Filter;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/form/Filter.js
// module id = 567
// module chunks = 0